import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <nav className="fixed top-0 w-full bg-gray-800 bg-opacity-80 backdrop-blur-md shadow-md z-50 p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-white font-bold text-2xl">TaskVerse</Link>
        <ul className="flex space-x-6">
          <li><Link to="/" className="text-gray-300 hover:text-blue-400 transition">Home</Link></li>
          <li><Link to="/about" className="text-gray-300 hover:text-blue-400 transition">About</Link></li>
          <li><Link to="/contact" className="text-gray-300 hover:text-blue-400 transition">Contact</Link></li>
          {token ? (
            <>
              <li><Link to="/dashboard" className="text-gray-300 hover:text-blue-400 transition">Dashboard</Link></li>
              <li>
                <button onClick={handleLogout} className="text-gray-300 hover:text-blue-400 transition">Logout</button>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login" className="text-gray-300 hover:text-blue-400 transition">Login</Link></li>
              <li><Link to="/register" className="text-gray-300 hover:text-blue-400 transition">Register</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
